export default __webpack_public_path__ + "static/l5-testimonial2-5fcb5a2e8dc23feb23a1d8be083a0411.jpg";